import React from 'react';

import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';

import './ToolbarForm.scss';

export const ToolbarForm = ({ editing, toggleEditing, onCancelClick, onSaveClick, allowEditing = false }) => {
  return (
    <Toolbar className='toolbar-form'>
      <Item location='before'>
        <span className='dx-form-group-caption'>Details</span>
      </Item>
      <Item location='after' visible={!editing && allowEditing}>
        <Button text='Bearbeiten' icon='edit' stylingMode='contained' type='default' onClick={toggleEditing} />
      </Item>
      <Item location='after' visible={editing}>
        <Button text='Speichern' stylingMode='contained' type='default' onClick={onSaveClick} />
      </Item>
      <Item location='after' visible={editing}>
        <Button text='Abbrechen' stylingMode='outlined' type='normal' onClick={onCancelClick} />
      </Item>
    </Toolbar>
  );
};
